import type { VipInfo } from '@/api/getVipInfo'
import React from 'react'
import { useTranslation } from 'react-i18next'
import Avatar from '@/components/Avatar/Avatar'
import diamond from './diamond.png'
import styles from './UserInfo.module.css'

const UserInfo: React.FC<{ username?: string; data: VipInfo | null }> = ({ username, data }) => {
  // 提取用户名首字母作为头像
  const avatarLetter = username?.charAt(0)
  const { t } = useTranslation()

  return (
    <div>
      <div className="flex items-center px-3 pt-3">
        {/* 头像 */}
        {avatarLetter ? (
          <div className="shrink-0 w-12 h-12 bg-[#7900FF] rounded-full flex items-center justify-center text-white text-xl font-bold mr-3">
            {avatarLetter}
          </div>
        ) : (
          <Avatar size={48} className="shrink-0 mr-3" />
        )}

        {/* 橙色VIP标签 */}
        {data?.effect && (
          <div className={styles.vipTag}>
            <img src={diamond} alt="diamond" />
            <span>Btok VIP</span>
          </div>
        )}

        {/* 用户名 */}
        {username ? (
          <div className={' text-lg font-medium ' + styles.username}>{username}</div>
        ) : (
          <div className={' text-lg font-medium ' + styles.username}>{data?.tgId}</div>
        )}
      </div>
      <div className="mx-4 mt-3 mb-1 font-medium" style={{ color: '#682b01', fontSize: '17px' }}>
        {data && data.effect && data.endTime
          ? t('home.expiredAt', { value: new Date(data.endTime * 1000).toLocaleDateString() })
          : ''}
      </div>
    </div>
  )
}

export default UserInfo
